export default __webpack_public_path__ + "static/card-image-4-06b1979fc3d9c7fe186b23d5f4b9fd4e.jpg";